import PdfPreview from 'domain/Updates/shared/Show/PdfPreview';
import PreviewImages from 'domain/Updates/shared/Show/PreviewImages';
import React from 'react';
import { DocumentDownloadDTO } from 'types/documents';
import Resource from 'util/resource/Resource';
import useResourceLegacy from 'util/resource/useResourceLegacy';

interface AttachmentPreviewProps {
  attachment: Promise<DocumentDownloadDTO>;
}

export default function AttachmentPreview({ attachment }: AttachmentPreviewProps) {
  const [attachmentResource] = useResourceLegacy<DocumentDownloadDTO>(async () => {
    return attachment;
  }, []);

  return (
    <Resource resource={attachmentResource} renderLoading={'Bar'}>
      {resourceAtt => {
        if (resourceAtt.contentType.startsWith('application/pdf')) {
          return <PdfPreview document={resourceAtt} />;
        } else if (resourceAtt.contentType.startsWith('image')) {
          return <PreviewImages imageUrls={[resourceAtt.path]} />;
        }
        return <></>;
      }}
    </Resource>
  );
}
